import type { ApiComponentScript } from 'data-source/types.wp'
import type {
  DSNCScript,
  DSNCScriptTagExternal,
  DSNCScriptTagInline,
} from 'shared-definitions/types'

export function ncScript(input: ApiComponentScript): DSNCScript | DSNCScript[] {
  const script = scriptMapper(input)
  if (!script) {
    return []
  }

  return {
    resource: 'nc-script',
    props: {
      script,
    },
  }
}

function scriptMapper(
  input: ApiComponentScript
): DSNCScriptTagInline | DSNCScriptTagExternal | null {
  if (!input) {
    return null
  }

  const type = input.attributes.type ?? 'text/javascript'

  if (input.attributes.src) {
    return {
      type,
      src: input.attributes.src,
      attributes: mapAttributes(input.attributes),
    }
  }

  if (input.content) {
    return {
      type,
      text: input.content,
      attributes: mapAttributes(input.attributes),
    }
  }

  return null
}

function mapAttributes(input: ApiComponentScript['attributes']): Record<string, string> {
  return Object.entries(input).reduce<Record<string, string>>((acc, [key, value]) => {
    if (key === 'src' || key === 'type') {
      return acc
    }
    acc[key] = value
    return acc
  }, {})
}
